/**
 * Hangman Gallows Canvas Renderer
 */
export class HangmanRenderer {
  constructor(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.dpr = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;
  }

  resize() {
    const rect = this.canvas.parentElement.getBoundingClientRect();
    const width = Math.min(rect.width, 320);
    const height = 220;

    this.canvas.width = width * this.dpr;
    this.canvas.height = height * this.dpr;
    this.canvas.style.width = `${width}px`;
    this.canvas.style.height = `${height}px`;

    this.ctx.scale(this.dpr, this.dpr);
  }

  render(strikes, isWon, isLost) {
    const width = this.canvas.width / this.dpr;
    const height = this.canvas.height / this.dpr;
    const ctx = this.ctx;

    ctx.clearRect(0, 0, width, height);

    // Gallows color
    ctx.strokeStyle = '#64748b';
    ctx.lineWidth = 4;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    // 1. Base Hill / Stand
    ctx.beginPath();
    ctx.moveTo(20, height - 20);
    ctx.lineTo(120, height - 20);
    ctx.stroke();

    // 2. Upright Pole
    ctx.beginPath();
    ctx.moveTo(50, height - 20);
    ctx.lineTo(50, 30);
    ctx.stroke();

    // 3. Top Crossbeam
    ctx.beginPath();
    ctx.moveTo(48, 30);
    ctx.lineTo(170, 30);
    ctx.stroke();

    // 4. Support Diagonal Strut
    ctx.beginPath();
    ctx.moveTo(50, 60);
    ctx.lineTo(80, 30);
    ctx.stroke();

    // 5. Rope
    ctx.strokeStyle = '#f59e0b';
    ctx.lineWidth = 2.5;
    ctx.beginPath();
    ctx.moveTo(160, 30);
    ctx.lineTo(160, 60);
    ctx.stroke();

    // Hangman Figure (strikes 1 to 6)
    ctx.strokeStyle = isLost ? '#f43f5e' : (isWon ? '#10b981' : '#f8fafc');
    ctx.lineWidth = 3.5;

    const nooseX = 160;
    const nooseY = 60;

    // Strike 1: Head
    if (strikes >= 1) {
      ctx.beginPath();
      ctx.arc(nooseX, nooseY + 16, 14, 0, Math.PI * 2);
      ctx.stroke();

      // Dead eyes if lost
      if (isLost) {
        ctx.lineWidth = 1.5;
        // X eyes
        ctx.strokeText('× ×', nooseX - 8, nooseY + 20);
        ctx.lineWidth = 3.5;
      }
    }

    // Strike 2: Torso
    if (strikes >= 2) {
      ctx.beginPath();
      ctx.moveTo(nooseX, nooseY + 30);
      ctx.lineTo(nooseX, nooseY + 80);
      ctx.stroke();
    }

    // Strike 3: Left Arm
    if (strikes >= 3) {
      ctx.beginPath();
      ctx.moveTo(nooseX, nooseY + 42);
      ctx.lineTo(nooseX - 22, nooseY + 62);
      ctx.stroke();
    }

    // Strike 4: Right Arm
    if (strikes >= 4) {
      ctx.beginPath();
      ctx.moveTo(nooseX, nooseY + 42);
      ctx.lineTo(nooseX + 22, nooseY + 62);
      ctx.stroke();
    }

    // Strike 5: Left Leg
    if (strikes >= 5) {
      ctx.beginPath();
      ctx.moveTo(nooseX, nooseY + 80);
      ctx.lineTo(nooseX - 20, nooseY + 120);
      ctx.stroke();
    }

    // Strike 6: Right Leg
    if (strikes >= 6) {
      ctx.beginPath();
      ctx.moveTo(nooseX, nooseY + 80);
      ctx.lineTo(nooseX + 20, nooseY + 120);
      ctx.stroke();
    }
  }
}
